export const info = {
    owner: 'apartmanbepinasplit',
    appDomain: 'apartmanbepinasplit.com',
    company: null,
    address: 'Dražanac 1',
    postalCode: 21000,
    city: 'Split',
    country: 'croatia',
    phone: '+385 91 246 0303',
    phoneShort: "+385 (0)91 246 0303",
    email: 'brankazelic0211@gmail.com',
    pin: null,
    sendTo: 'brankazelic0211@gmail.com',
    googleMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d723.4468190421678!2d16.43133766840007!3d43.506773040342466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13355df881b12eb1%3A0xeb60bbde62b07fc3!2sDra%C5%BEanac%20ul.%201%2C%2021000%2C%20Split!5e0!3m2!1sen!2shr!4v1720615139193!5m2!1sen!2shr'
  }


// WEBPACK FOOTER //
// ./src/config/info.js